import {Service} from "@/apiServices/Service";

export class KpiService extends Service{
    constructor() {
        super('kpi/');
    }

    traerKpiPaciente(idPaciente) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener']),idPaciente)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}